import { View } from "@react-pdf/renderer";
import {
  ResumePDFSection,
  ResumePDFText,
  ProjectPDFLink,
  ResumePDFDescription,
} from "components/Resume/ResumePDF/common";
import { ResumePDFIcon } from "components/Resume/ResumePDF/common/ResumePDFIcon";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeCertificate } from "lib/redux/types";
import { ResumePDFSectionWithSubsections } from './common/index';

export const ResumePDFCertificate = ({
  heading,
  certifications,
  themeColor,
  isPDF,
  isSectionSelected
}: {
  heading: string;
  certifications: ResumeCertificate[];
  themeColor: string;
  isPDF: boolean;
  isSectionSelected?: boolean;
}) => {
  return (
    <ResumePDFSectionWithSubsections themeColor={themeColor} heading={heading}>
      {certifications.map(
        ({ certificate, certificateLink, descriptions }, idx) => (
          <View key={idx} wrap={false}>
            <View
              style={{
                ...styles.flexRowBetween,
                marginTop: spacing["0.5"],
              }}
            >
              <View
                style={{
                  ...styles.flexRow,
                  gap: spacing["2"],
                }}
              >
                <ResumePDFText bold={true}>{certificate}</ResumePDFText>
                {certificateLink && (
                  <ProjectPDFLink src={certificateLink}>
                    <ResumePDFIcon
                      type="url"
                      isPDF={isPDF}
                      themeColor={themeColor}
                    />
                  </ProjectPDFLink>
                )}
              </View>
            </View>
            <View style={{ ...styles.flexCol, marginTop: spacing["0.5"] }}>
              <ResumePDFDescription items={descriptions} />
            </View>
          </View>
        )
      )}
    </ResumePDFSectionWithSubsections>
  );
};
